//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import { Params$AdminBillingDocumentController_createCreditNote } from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminBillingDocumentController_createCreditNote = () =>
  useApiClientMutation<
    Params$AdminBillingDocumentController_createCreditNote,
    never
  >({ method: 'AdminBillingDocumentController_createCreditNote' });
